import { store } from '@wordpress/interactivity';

const { state } = store('mediapress-listicle', {
  state: {
    get ranges() {
      const totalItems = state.totalItems || 0;
      const perPage = state.perPage || -1;

      if (perPage <= 0 || totalItems === 0) return [];

      // Hide pagination when there's only one page or less
      if (state.totalPages <= 1) return [];

      const ranges = [];

      for (let i = 0; i < state.totalPages; i += 1) {
        const page = i + 1;

        if (state.isReversed) {
          const start = totalItems - i * perPage;
          const end = Math.max(start - perPage + 1, 1);
          ranges.push({ text: `${start} - ${end}`, page });
        } else {
          const start = i * perPage + 1;
          const end = Math.min(start + perPage - 1, totalItems);
          ranges.push({ text: `${start} - ${end}`, page });
        }
      }

      return ranges;
    },
  },
  actions: {
    gotoPage: (event) => {
      const { totalPages, page } = state;
      const selectedPageNumber = parseInt(event.target.dataset.page, 10);

      if (page !== totalPages) {
        state.page = selectedPageNumber;
      }

      state.selectedPage = selectedPageNumber;
    },
  },
});
